<template>
  <div class="credicard">
    <div class="cardframe">
      <div>
        <label for="card-number-frame">Card number</label>
        <div class="input-container card-number" v-bind:class="{ error: errors['card-number'] }">
          <div class="card-number-frame"></div>
        </div>
      </div>

      <div class="date-and-code">
        <div>
          <label for="expiry-date">Expiry date</label>
          <div class="input-container expiry-date" v-bind:class="{ error: errors['expiry-date'] }">
            <div class="expiry-date-frame"></div>
          </div>
        </div>

        <div>
          <label for="cvv">Security code</label>
          <div class="input-container cvv" v-bind:class="{ error: errors['cvv'] }">
            <div class="cvv-frame"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="pay-block">
      <button
        class="btn btn-blue"
        type="button"
        @click="pay()"
        :disabled="isButtonDisabled"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

/* global Frames */

const CONTINUE_TEXT = 'Continue';
const PROCESSING_TEXT = 'Processing...';

export default {
  name: 'SubscriptionPaymentCreditCard',
  components: {

  },
  data: () => ({
    isButtonDisabled: true,
    errors: {
      'card-number': false,
      'expiry-date': false,
      cvv: false,
    },
    buttonText: CONTINUE_TEXT,
  }),
  computed: {
    ...mapState('payment', ['amount']),
  },
  methods: {
    loadCheckoutFrames() {
      if (window.Frames) {
        this.initCheckout();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.checkout.com/js/framesv2.min.js';

      script.onload = () => {
        this.initCheckout();
      };

      document.head.appendChild(script);
    },
    pay() {
      this.buttonText = PROCESSING_TEXT;
      this.isButtonDisabled = true;
      Frames.submitCard();
    },
    initCheckout() {
      Frames.init({
        publicKey: process.env.VUE_APP_CHECKOUT_PK,
        acceptedPaymentMethods: [
          'Visa',
          'Maestro',
          'Mastercard',
          'American Express',
          'Diners Club',
          'Discover',
          'JCB',
          'Mada',
        ],
        frameValidationChanged: (event) => {
          this.errors[event.element] = event.isEmpty ? true : !event.isValid;
          this.isButtonDisabled = Object.values(this.errors).some((err) => !!err);
        },
        cardTokenized: async (data) => {
          await this.createPayment(data.token);
        },
        style: {
          base: {
            color: '#ddd',
            fontSize: '16px',
            textAlign: 'center',
          },
        },
      });
    },
    async createPayment(token) {
      try {
        await this.$store.dispatch('payment/createCreditCardPayment', token);
        this.$toasted.show('Payment success');
        this.$router.push('/account/subscription');
      } catch (e) {
        this.buttonText = CONTINUE_TEXT;
        Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
        Frames.init();
        this.$store.commit('payment/setError', e.response.data.message);
      }
    },
  },
  created() {

  },
  mounted() {
    this.loadCheckoutFrames();
  },
  destroyed() {
    Frames.removeAllEventHandlers(Frames.Events.CARD_TOKENIZED);
  },
};
</script>

<style scoped lang="less">
  .credicard {
    margin-top: 30px;

    .cardframe {
      display: flex;
      flex-direction: column;

      label {
        font-size: .75rem;
        color: #b3b3b3;
        display: block;
        margin-bottom: 10px;
      }

      .input-container {
        background-color: #333333;
        border-radius: 5px;
        margin-bottom: 30px;
        border: 1px solid transparent;

        &.error {
          border: 1px solid red;
        }

        .card-number-frame, .expiry-date-frame, .cvv-frame {
          height: 45px;
          padding: 0 15px;
        }
      }

      .date-and-code {
        display: flex;
        justify-content: space-between;

        > div {
          width: 48%;
          flex-grow: 0;
        }
      }
    }

    .pay-block {
      text-align: center;
    }
  }

  @media (max-width: 768px) {
    .credicard {
      .cardframe {
        .date-and-code {
          display: block;

          > div {
            width: 100%;
          }
        }
      }
    }
  }
</style>
